export default __webpack_public_path__ + "static/media/font.d4a7dc0c.woff2";